export const builtInSpec = {
    nodes: {
        doc: {
            raw: true,
            content: 'block+',
        },
        paragraph: {
            content: 'inline*',
            group: 'block',
            matchSelector: 'p',
            toDOM: 'p',
        },
        hard_break: {
            inline: true,
            group: 'inline',
            selectable: false,
            matchSelector: 'br',
            toDOM: 'br',
        },
        text: {
            raw: true,
            group: 'inline',
        },
    },
    marks: {},
};
//# sourceMappingURL=schema.js.map